import {
  Checkbox,
  IconButton,
  TableCell,
  TableHead as TableHeadMUI,
  TableRow,
  TableSortLabel,
  useTheme,
} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import { ChangeEventHandler } from 'react'
import { ETranslationNs } from 'src/types'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
  handleSortChange: (sortName: string) => () => void
  activeSort: string
  sortDirection: 'desc' | 'asc'
  isAllChecked: boolean
  isIndeterminated: boolean
  handleAllItemsCheck: ChangeEventHandler<HTMLInputElement>
  handleItemsRemove: () => void
  isAllUnchecked: boolean
}

export const TableHead = ({
  isAllUnchecked,
  handleItemsRemove,
  handleSortChange,
  activeSort,
  sortDirection,
  isAllChecked,
  isIndeterminated,
  handleAllItemsCheck,
}: IProps) => {
  const theme = useTheme()

  return (
    <TableHeadMUI>
      <TableRow>
        <TableCell align="center">
          <Checkbox
            indeterminate={isIndeterminated}
            sx={{ color: theme.palette.custom.grey2 }}
            onChange={handleAllItemsCheck}
            checked={isAllChecked}
          />
        </TableCell>
        <TableCell>
          <TableSortLabel
            onClick={handleSortChange('scan_draft.batch_id')}
            active={activeSort === 'scan_draft.batch_id'}
            direction={sortDirection}
          >
            <HelperWrapper t="batch-id-table-column" ns={ETranslationNs.Scans} />
          </TableSortLabel>
        </TableCell>
        <TableCell align="center">
          <TableSortLabel
            onClick={handleSortChange('account.account_holder')}
            active={activeSort === 'account.account_holder'}
            direction={sortDirection}
            sx={{
              marginLeft: '20px',
            }}
          >
            <HelperWrapper t="scan-account-table-column" ns={ETranslationNs.Scans} />
          </TableSortLabel>
        </TableCell>
        <TableCell align="center">
          <TableSortLabel
            onClick={handleSortChange('product.name')}
            active={activeSort === 'product.name'}
            direction={sortDirection}
            sx={{
              marginLeft: '20px',
            }}
          >
            <HelperWrapper t="scan-product-table-column" ns={ETranslationNs.Scans} />
          </TableSortLabel>
        </TableCell>
        <TableCell>
          <TableSortLabel
            onClick={handleSortChange('step.name')}
            active={activeSort === 'step.name'}
            direction={sortDirection}
          >
            <HelperWrapper t="scan-step-table-column" ns={ETranslationNs.Scans} />
          </TableSortLabel>
        </TableCell>
        <TableCell align="center">
          <TableSortLabel
            onClick={handleSortChange('change.created_at')}
            active={activeSort === 'change.created_at'}
            direction={sortDirection}
            sx={{
              marginLeft: '20px',
            }}
          >
            <HelperWrapper t="table-created-column" />
          </TableSortLabel>
        </TableCell>
        <TableCell align="center">
          <IconButton disabled={isAllUnchecked} onClick={handleItemsRemove}>
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    </TableHeadMUI>
  )
}
